import {useEffect, useState} from 'react';
import {useAppContext} from '../../../../context/Context';
import api from '../../../../utils/api';
import {
    setBottomBarError,
    setBottomBarSucces,
} from '../../../../utils/Functions';
import {ACTION} from '../../../../context/actionTypes';

export const DEFAULT_INTRODUCTION_TEXT = "Bonjour et bienvenue sur Virteem Companion ! Je suis un assistant conçu pour vous aider à trouver des informations précises dans notre base de connaissances. Posez-moi des questions spécifiques sur notre domaine d'expertise, et je ferai de mon mieux pour vous fournir une réponse pertinente basée sur les documents disponibles. Si vous avez des questions générales ou souhaitez simplement discuter, je risque de ne pas être très bavard. Essayez de poser une question précise pour obtenir des résultats optimaux. Merci !";

export default function useIntroductionMessage() {
    const [{user}, dispatch] = useAppContext();

    const [introductionText, setIntroductionText] = useState(null);

    useEffect(() => {
        const getIntroductoryMessage = async () => {
            try {
                const response = await api.get(`/company/${user.company_id}/text`);
                setIntroductionText(response.data || DEFAULT_INTRODUCTION_TEXT);
            } catch (error) {
                console.error('Failed to load introductory text', error);
                setBottomBarError(dispatch, error);
                setIntroductionText(DEFAULT_INTRODUCTION_TEXT);
            }
        };

        getIntroductoryMessage();
    }, [dispatch, user.company_id]);

    const handleSubmit = async () => {
        try {
            // Send introductoryText to backend
            await api.patch(`/company/${user.company_id}/text`, {text: introductionText === DEFAULT_INTRODUCTION_TEXT ? null : introductionText});
            dispatch({type: ACTION.SET_GENERIC_MODAL, payload: null});
            setBottomBarSucces(
                dispatch,
                "Votre message d'introduction a été mis à jour !"
            );
        } catch (error) {
            setBottomBarError(dispatch, error);
        }
    };
    return [
        {
            introductionText,
        },
        {setIntroductionText, handleSubmit},
    ];
}
